import { FilterState, FilterStateAzure } from './types';

export const TIME_RANGE_OPTIONS = [
  { label: 'Last 5 Min', value: 'last_5_minutes' },
  { label: 'Last 10 Min', value: 'last_10_minutes' },
  { label: 'Last 15 Min', value: 'last_15_minutes' },
  { label: 'Last 30 Min', value: 'last_30_minutes' },
  { label: 'Last 1 Hr', value: 'last_1_hour' },
  { label: 'Last 24 Hrs', value: 'last_24_hours' },
  { label: 'Last 7 Days', value: 'last_7_days' },
  { label: 'Last 30 Days', value: 'last_30_days' },
  { label: 'Last 90 Days', value: 'last_90_days' },
  { label: 'Older Than 90 Days', value: 'more_than_90_days' },

] as const;

export type TimeRangeValue =
  | typeof TIME_RANGE_OPTIONS[number]['value']
  | 'custom';

export const DEFAULT_FILTERS: FilterState = {
  department: [],
  capability: [],
  vendor: [],
  team: [],
  subCapability: [],
  technology: [],
  timeRange: 'last_15_minutes',
  severity: [],
  status: [{label: 'Open', value: 'Open'},{label: 'Reopen', value: 'Reopen'}],
  sector: [],
  miscellaneousSector: [],
  domains: [],
  programs: [],
  businessUnits: [],
  sources: [],
  cmdb_ci: [],
  additionalFilters: [],
  assignmentGroup: [],
  assignmentGroupListName: [],
  priority: [],
  alertCategory: [{ label: 'ALL', value: 'ALL' }],
  isDandAIAG: [],
};

export const DEFAULT_FILTERS_AZURE: FilterStateAzure = {
  timeRange: 'last_24_hours',
  mappedSeverity: [],
  status: [{label: 'Fired', value: 'Fired'},{label: 'Resolved', value: 'Resolved'}],
  subscriptions: [],
  resourceGroups: [],
  resourceTypes: [],
  signalTypes: [],
  monitoringServices: [],
};
